import { Pipe, PipeTransform } from '@angular/core'

/**
 * Tslint forbids us to use expressions in templates
 * If we want to know if an element is selected its better to use pipes:
 *
 * Usage:
 *   value | highlight:array
 * Example:
 *   {{ element | highlight:selectedItems }}
 *   formats to: true or false
 */
@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {
    transform<T>(value: T, elements: Array<T>): boolean {
        return elements.includes(value)
    }
}
